import React, { Component } from 'react';
import { Button, Card, Form, message, Table } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import moment from 'moment';
import util from '@util/index';

import { queryFilePreview } from '@api/pub/attachment';
import { queryDeleteIncuDatabase, querySaveIncuDatabase } from '@api/incubator/database';

import UploadFile from '@comm/upload/UploadFile';
import DescriptionList from '@comm/DescriptionList';

const FormItem = Form.Item;
const { Description } = DescriptionList;

class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataItem: this.props.data,
      showUpload: false,
      delFiles: [],
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataItem: nextProps.data,
    });
  }

  showUpload = () => {
    this.setState({ showUpload: true });
  };

  /**
   *文件删除
   */
  fileRemove = file => {
    const { delFiles } = this.state;
    delFiles.push(file);
    this.setState({ delFiles });
  };

  uploadSubmit = () => {
    const { uuid } = this.props.params;
    const params = {
      itemUuid: uuid,
      ...this.props.form.getFieldsValue(),
    };

    if (this.state.delFiles.length > 0) {
      this.state.delFiles.map(item => {
        queryDeleteIncuDatabase({
          businessUuid: uuid,
          attachmentUuid: item.uuid,
        }).then(res => {});
        return item;
      });
    }
    querySaveIncuDatabase(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.setState({ showUpload: false });
        this.props.getInfo();
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    return [
      {
        title: '合同编号',
        dataIndex: 'no',
        render: (text, record) => (
          <Link to={`/incubator/contract/${record.businessUuid}/info`}>
            {record.isTransfer ? <span style={{ color: 'yellow' }}>转</span> : null}
            {text}
          </Link>
        ),
      },
      {
        title: '合同周期',
        dataIndex: 'beginDate',
        render: (text, record) =>
          record.beginDate && record.deadline ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.deadline / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '交易类型',
        dataIndex: 'type',
        key: 'type',
        render: (text, record) => {
          return <span>{record.price ? '收费注册' : '免费注册'}</span>;
        },
      },
      {
        title: '合同金额',
        dataIndex: 'price',
        key: 'price',
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
      },
      {
        title: '推荐人员',
        dataIndex: 'recommend',
        key: 'recommend',
        render: (text, record) => {
          return (
            <span>
              {text}
              <span style={{ marginLeft: '10px' }}>{record.recommendTel}</span>
            </span>
          );
        },
      },
      {
        title: '状态',
        dataIndex: 'isCurrent',
        key: 'isCurrent',
        render: (text, record) => {
          return <span>{text ? '当前关联' : '历史关联'}</span>;
        },
      },
    ];
  };

  render() {
    const {
      dataItem,
      dataItem: { addresses = [], settleds = [], moveOutFiles = [], currentSettled = {} },
      showUpload,
    } = this.state;
    const { getFieldDecorator } = this.props.form;

    let day = 0;
    if (currentSettled.deadline) {
      day = Math.floor((dataItem.moveOutDate - currentSettled.deadline) / 86400000);
    }
    return (
      <div className="form-open">
        <Card title="地址详情">
          <DescriptionList size="large" col={3}>
            <Description term="孵化器">{dataItem.incubator}</Description>
            <Description term="公司名称">{dataItem.custom}</Description>
            <Description term="项目名称">{dataItem.projectName}</Description>
            <Description term="开始时间">
              {dataItem.updateDate
                ? moment.unix(dataItem.updateDate / 1000).format('YYYY-MM-DD')
                : ''}
            </Description>
            <Description term="到期时间">
              {currentSettled.deadline
                ? moment.unix(currentSettled.deadline / 1000).format('YYYY-MM-DD')
                : ''}
            </Description>
            <Description term="迁出时间">
              {dataItem.moveOutDate
                ? moment.unix(dataItem.moveOutDate / 1000).format('YYYY-MM-DD')
                : ''}
              {day && day > 0 ? (
                <span style={{ color: 'red', marginLeft: '10px' }}>（逾期{day}天）</span>
              ) : (
                ''
              )}
            </Description>
          </DescriptionList>

          <DescriptionList size="large" col={1}>
            <Description term="注册地址">
              <div>
                {addresses.map(item => {
                  return <div key={item.url}>{item.name}</div>;
                })}
              </div>
            </Description>
          </DescriptionList>

          <DescriptionList size="large" col={1}>
            <Description term="关联基础孵化合同" />
            <Table
              rowKey="uuid"
              pagination={false}
              columns={this.columns()}
              dataSource={settleds}
            />
          </DescriptionList>

          <DescriptionList size="large" col={3} style={{ marginTop: '15px' }}>
            <Description term="迁出附件">
              {showUpload ? (
                <Form style={{ position: 'relative' }}>
                  <FormItem>
                    {getFieldDecorator('files', {
                      initialValue: moveOutFiles || [],
                    })(<UploadFile type="ghost" isPreview onRemove={this.fileRemove} />)}
                  </FormItem>
                  <Button
                    type="primary"
                    style={{
                      position: 'absolute',
                      top: '0',
                      left: '130px',
                      marginTop: '3px',
                    }}
                    onClick={this.uploadSubmit}
                  >
                    确认
                  </Button>
                </Form>
              ) : (
                <div>
                  {(moveOutFiles || []).map(item => {
                    return (
                      <div key={item.url}>
                        <a onClick={() => queryFilePreview(item)}> {item.name}</a>
                      </div>
                    );
                  })}
                  <Button onClick={this.showUpload} style={{ marginTop: '5px' }}>
                    重新上传
                  </Button>
                </div>
              )}
            </Description>
          </DescriptionList>

          <DescriptionList size="large" col={1}>
            <Description term="迁出说明">{dataItem.moveOutRemark}</Description>
          </DescriptionList>
        </Card>
      </div>
    );
  }
}

export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(Form.create()(Open));



// WEBPACK FOOTER //
// ./src/components/incubator/oregistappMoveOut/FormOpen.js